export default "__VITE_ASSET__WqsdqOzx__"